import React, { useState, useEffect } from "react";
import icoDownload from '../../assets/img/ico-download.svg';
import api from "../Services/api";

const DocumentLink = (props: any) => {
  const [file, setFile] = useState<any[]>([]);

  useEffect(() => {

    api.get(props.url)
      .then(response => {
        setFile(response.data.results);
      })
      .catch(error => {
        throw new Error(error);
      });
  }, [props.url]);


  return (
    <>
      {file?.map((item, index) => (


        <div key={index} className="col-md-6 col-lg-5">
          <a rel="noreferrer" href={item.URL} className="box-pdf mt-4 mb-10" target="_blank">
            <img  src={item.Imgurl ? item.urlImg : props.fileImg} alt="Organograma" className="mb-5" />

 
            <div className="container">
              <div className="row">
                <div className="col-xs-6">
                  <strong>{item.Title} </strong>
                </div>
                <div className="col-xs-6">
                  <div className="card-comunicado__btn">

                    <a rel="noreferrer" href={item.URL} target="_blank" className="btn btn-primary rounded p-0 btn-100">
                      <img style={{ maxWidth: "55%" }} src={icoDownload} alt="Ícone" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      ))}
    </>

  )
};
export default DocumentLink;